import React from 'react'
import { connectNumericMenu } from 'react-instantsearch-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Divider, Typography } from '@material-ui/core'
import { useRouteMatch } from 'react-router';

const useStyles = makeStyles({
  conatinerList: {
    width: "100%"
  },
  contentList: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  itemLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 30,
  },
});

function AlgoliaDiscounts({items, refine}) {

  const matchCategory = useRouteMatch('/c-:c_id-:c_name');

  const classes = useStyles();

  if (!items.length) return (
    <div>
      {/* No hay descuentos */}
    </div>
  )

  return (
    <Box className={classes.conatinerList} mb={2}>
      <Box mb={1} clone>
        <Divider />
      </Box>
      <Typography variant='h5'>Descuentos</Typography>
      <Box my={1}>
        <Divider />
      </Box>
      <ul className={classes.contentList}>
        {items
          .filter(item => matchCategory?.params?.c_id === '31' ? item.label !== 'All' : item.label !== 'Todos')
          .map((item, index) => (
            <li key={`discount-item-filter-${index}`}>
              <div
                className={classes.itemLabel}
                style={{cursor: 'pointer'}}
                onClick={(e) => {
                  e.preventDefault()
                  refine(item.value)
                }}
                >
                  <div>
                    <Box clone mr={2}>
                      <input
                        type="radio"
                        checked={item.isRefined}
                        name='discount-filter'
                      />
                    </Box>
                    <Typography
                      display="inline"
                      variant="body1"
                      style={{fontWeight: item.isRefined ? 'bold' : 'normal'}}
                    >
                      {item.label === 'All' ? 'Todos' : item.label}
                    </Typography>
                  </div>
                  <Typography variant="body1">{item.count}</Typography>
              </div>
            </li>
          ))}
      </ul>
    </Box>
  )
}

export default connectNumericMenu(AlgoliaDiscounts)